export const STARFIRE_COLOR = '#a855f7';
export const STARFIRE_ACCENT = '#ffd166';
export const STARFIRE_HOT_COLOR = '#fff4c2';
export const STARFIRE_PLASMA_COLOR = '#7c3aed';
export const STARFIRE_SMOKE_COLOR = '#352d45';
